export class ReleaseOrderTypeCodes {
    public static readonly FullContainer = 'FUL';
    public static readonly EmptyContainer = 'EMP';
    public static readonly Stripping = 'STR';
    public static readonly Cusin = 'CUSI';
    public static readonly Conte = 'STUF';
    public static readonly Soc = 'SOC';
    public static readonly SocLine = 'SOC';
    public static readonly SoLine = 'SO';

    public static readonly SupportedCreateServiceRequestTypes = [
        ReleaseOrderTypeCodes.FullContainer,
        ReleaseOrderTypeCodes.EmptyContainer,
        ReleaseOrderTypeCodes.Stripping,
        ReleaseOrderTypeCodes.Cusin,
        ReleaseOrderTypeCodes.Conte,
        ReleaseOrderTypeCodes.Soc
    ];
    public static readonly SocLineCodes = [ReleaseOrderTypeCodes.SocLine, ReleaseOrderTypeCodes.SoLine];
}

